module.exports = __webpack_public_path__ + "img/welfare-share.b93682b8.png";